import { getAgentId, getBotId } from 'conversations-thread-data/assignees/public/operators';
import { getUserId, hasConversationsInteract } from 'conversations-thread-data/auth/public/selectors';
import { EMAIL_GENERIC_CHANNEL_ID, FB_MESSENGER_GENERIC_CHANNEL_ID, FORMS_GENERIC_CHANNEL_ID, LIVE_CHAT_GENERIC_CHANNEL_ID } from 'conversations-thread-data/generic-channels/public/constants';
import { getIsFiltered, getIsSoftDeleted } from 'conversations-thread-data/thread-details/public/operators';
import { CONVERSATION } from 'customer-data-objects/constants/ObjectTypes';
import { useRef } from 'react';
import { useSelector } from 'react-redux';
import ReassignmentDropdown from 'routing-ui/reassignment/components/ReassignmentDropdown';
import { getChannelTypeByGenericId } from 'svh-onboarding-config-shared-lib/migration/operators/getChannelTypeByGenericId';
import { getUsageTracker } from '../usage-tracking/clients/usageTracker';
import CannotReassignTooltip from './CannotReassignTooltip';
import { useReassignment } from './hooks/useReassignment';
import { endReassignPerf } from './operators/performance-tracking';
import { View } from 'foundations-components/components/View';
import { ROUTING_SOURCE } from 'routing-ui/shared/constants/routing-source';
import { jsx as _jsx } from "react/jsx-runtime";
const useAssignmentPerformance = currentAssignee => {
  const currentAssigneeId = currentAssignee ? getAgentId(currentAssignee) || getBotId(currentAssignee) : null;
  const lastAssigneeId = useRef(currentAssigneeId);
  if (lastAssigneeId.current !== currentAssigneeId) {
    endReassignPerf();
  }
};
const checkCanRouteToAvailable = genericChannelId => [EMAIL_GENERIC_CHANNEL_ID, FB_MESSENGER_GENERIC_CHANNEL_ID, FORMS_GENERIC_CHANNEL_ID, LIVE_CHAT_GENERIC_CHANNEL_ID].includes(genericChannelId);
const useDisableReassignment = threadDetails => {
  const canReassign = useSelector(hasConversationsInteract);
  const filtered = !!getIsFiltered(threadDetails);
  const softDeleted = !!getIsSoftDeleted(threadDetails);
  return {
    canReassign,
    disabled: !canReassign || filtered || softDeleted,
    thread: {
      filtered,
      softDeleted
    }
  };
};
const GenericReassignmentDropdown = ({
  currentAssignee,
  genericChannelId,
  inboxId,
  reassignThread,
  routeToTeam,
  teams,
  threadDetails,
  threadId,
  unassignThread
}) => {
  const currentUserId = useSelector(getUserId);
  const {
    canReassign,
    disabled,
    thread
  } = useDisableReassignment(threadDetails);
  const reassign = useReassignment({
    genericChannelId,
    reassignThread,
    routeToTeam,
    threadDetails,
    threadId,
    unassignThread
  });
  // The reassignment dropdown does not accept `null` as a value, so we need to default to `undefined`
  const channelType = getChannelTypeByGenericId(genericChannelId) || undefined;
  useAssignmentPerformance(currentAssignee);
  return /*#__PURE__*/_jsx(View, {
    paddingInlineEnd: "400",
    "data-test-id": "selenium-test-marker-reassignment-dropdown",
    children: /*#__PURE__*/_jsx(CannotReassignTooltip, {
      hasPermission: canReassign,
      threadDeleted: thread.softDeleted,
      threadFiltered: thread.filtered,
      children: /*#__PURE__*/_jsx(ReassignmentDropdown, {
        canRouteToAvailable: checkCanRouteToAvailable(genericChannelId),
        channelType: channelType,
        currentAssignee: currentAssignee,
        currentUserId: currentUserId,
        "data-test-id": "toolbar-conversation-owner-dropdown",
        disabled: disabled,
        objectTypeId: CONVERSATION,
        reassign: reassign,
        routingSource: ROUTING_SOURCE.INBOX,
        teams: teams,
        workspaceId: inboxId,
        usageTracker: getUsageTracker().tracker
      })
    })
  });
};
GenericReassignmentDropdown.displayName = 'GenericReassignmentDropdown';
export default GenericReassignmentDropdown;